<!--  <div *ngIf="vehicle!=null" #imageContent>

<div id="imgModal" class="slide-modal wow zoomIn" style="display: block;">

  <div class="slide-modal-content">
      <span class="close cursor" (click)="closeModal()">
        <fa-icon [icon]="faTimesCircle"></fa-icon>
      </span>
      <div class="img-slides" *ngFor="let image of vehicle.images; let i = index">
          <img src="{{image.url}}">
      </div>
      <a class="prev" (click)="plusSlides(-1)"><mat-icon>navigate_before</mat-icon></a>
      <a class="next" (click)="plusSlides(1)"><mat-icon>navigate_next</mat-icon></a>

  </div>
</div>
</div> -->


<div *ngIf="vehicleImagesModel!=null" #imageContent>
  <!-- <div class="image-row">
    <div class="image-column" >
        <img src="{{vehicle.images[0].url}}" (click)="openModal();currentSlide(0+1)" class="img-fluid cursor">
    </div>
  </div> -->
  <div id="imgModal" class="slide-modal wow zoomIn" style="display: block;">

    <div class="slide-modal-content">
        <span class="close cursor" (click)="closeModal()">
          <fa-icon [icon]="faTimesCircle"></fa-icon>
        </span>
        <div class="img-slides" *ngFor="let vehicle of vehicleImagesModel; let i = index">
          <img  [src]="attachmentService
          .getImageLink(vehicle.vehicleImagesID,attachmentScopesEnum.Vehicle, attachmentTypeEnum.CarImage,'ok')">
            <!-- <img src="{{image.url}}"> -->
        </div>

        <a class="prev" (click)="plusSlides(-1)"><mat-icon>navigate_before</mat-icon></a>
        <a class="next" (click)="plusSlides(1)"><mat-icon>navigate_next</mat-icon></a>
        <!-- <div class="image-row">
            <div class="image-column" *ngFor="let image of images; let i = index">
                <img class="images" (click)="currentSlide(i+1)" src="{{image.url}}">
            </div>
        </div> -->
    </div>
  </div>

  </div>
